import { LinearProgress } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import useStyles from "../hooks/useStyles";
import Help from "./Help";
import { OutputBody, OutputBox, OutputButton, OutputColor, OutputHeaderText, OutputFooter, OutputHeader } from "./OutputBox";
var SubmittingOutput = function SubmittingOutput(props) {
  var getPasteLink = props.getPasteLink,
    onClose = props.onClose;
  var t = useTranslation()[0];
  var classes = useStyles();
  return React.createElement(OutputBox, null, React.createElement(OutputHeader, {
    title: t("submitting"),
    color: OutputColor.Gray
  }, React.createElement(Help, {
    getPasteUrl: getPasteLink,
    pasteDisabled: true
  }), React.createElement(OutputButton, {
    label: t("button.close"),
    onClick: onClose,
    disabled: true,
    dataCy: "close-btn"
  })), React.createElement(OutputBody, null, React.createElement("div", {
    style: {
      textAlign: "center",
      margin: "10px 0px"
    }
  }, React.createElement(OutputHeaderText, {
    variant: "h5"
  }, t("submittingToServer")), React.createElement(LinearProgress, {
    style: {
      width: "42%",
      margin: "0 auto"
    }
  }))), React.createElement(OutputFooter, {
    color: OutputColor.Gray
  }, React.createElement(OutputButton, {
    disabled: true,
    label: t("button.submit"),
    dataCy: "submit-btn",
    className: classes.blueButton
  })));
};
export default SubmittingOutput;